import { Component, Input } from '@angular/core';
import { SyncState } from '@era/locations-sdk';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'era-device-sync-status-indicator',
  templateUrl: './device-sync-status-indicator.component.html',
  styleUrls: ['./device-sync-status-indicator.component.scss'],
  imports: [FaIconComponent],
})
export class DeviceSyncStatusIndicatorComponent {
  syncState = SyncState;
  @Input() status: SyncState;
}
